export enum GetChatsMode {
    my = 1,
    withMe,
    botsAndQueue,
    all,
    archive
}